import React, { useContext, useState, useEffect } from "react";
import AuthContext from "../../store/auth-context";
import { baseUrl } from "../../Config";
import "./EmailTrackingPage.css";
import { SendGetRequest } from "../../actions/Actions";
import SubscriptionsTable from "../Table/SubscriptionsTable";
import EmailTrackingTable from "./EmailTrackingTable";

const EmailTrackingPage = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [items, setItems] = useState([]);
  const [customers, setCustomers] = useState([]);

  const authContext = useContext(AuthContext);

  const subscriptionUrl = baseUrl + "/api/subscription/all";
  const itemsUrl = baseUrl + "/api/item/all";
  const customersUrl = baseUrl + "/api/customer/all";

  useEffect(() => {
    SendGetRequest(customersUrl, authContext.token, customersHandler);
  }, []);

  const customersHandler = (data) => {
    setCustomers(data);
  }

  const refreshHandler = () => {
    SendGetRequest(customersUrl, authContext.token, customersHandler);
  }

  return (
    <div className="SubscriptionPage">
      <EmailTrackingTable customers={customers} refreshHandler={refreshHandler} />
    </div>
  );
};

export default EmailTrackingPage;
